import {
  FETCH_COMPANY_SETTINGS_REQUEST,
  FETCH_COMPANY_SETTINGS_SUCCESS,
  FETCH_COMPANY_SETTINGS_FAILURE,
  CREATE_COMPANY_SETTINGS_REQUEST,
  CREATE_COMPANY_SETTINGS_SUCCESS,
  CREATE_COMPANY_SETTINGS_FAILURE,
  UPDATE_COMPANY_SETTINGS_REQUEST,
  UPDATE_COMPANY_SETTINGS_SUCCESS,
  UPDATE_COMPANY_SETTINGS_FAILURE,
  DELETE_COMPANY_SETTINGS_REQUEST,
  DELETE_COMPANY_SETTINGS_SUCCESS,
  DELETE_COMPANY_SETTINGS_FAILURE,
} from "../actions/types";

const initialState = {
  companySettings: [],
  loading: false,
  error: null,
  message: "",
};

const companySettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests
    case FETCH_COMPANY_SETTINGS_REQUEST:
    case CREATE_COMPANY_SETTINGS_REQUEST:
    case UPDATE_COMPANY_SETTINGS_REQUEST:
    case DELETE_COMPANY_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    // Fetch success
    case FETCH_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        companySettings: action.payload,
        message: "Company settings loaded successfully",
      };

    // Create success
    case CREATE_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        companySettings: [...state.companySettings, action.payload],
        message: "Company settings created successfully",
      };

    // Update success
    case UPDATE_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        companySettings: state.companySettings.map((setting) =>
          setting.id === action.payload.id ? action.payload : setting
        ),
        message: "Company settings updated successfully",
      };

    // Delete success
    case DELETE_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        companySettings: state.companySettings.filter(
          (setting) => setting.id !== action.payload
        ),
        message: "Company settings deleted successfully",
      };

    // Failures
    case FETCH_COMPANY_SETTINGS_FAILURE:
    case CREATE_COMPANY_SETTINGS_FAILURE:
    case UPDATE_COMPANY_SETTINGS_FAILURE:
    case DELETE_COMPANY_SETTINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default companySettingsReducer;
